import { IFooterConfig } from '@pendwa/common-browser/components/Navs/Footer/types.js';
import { IContextPageDataViewer } from '@pendwa/common-browser/context/PageData/index.js';
import { hasPermissionsAnd } from '@pendwa/common/core/permission/helpers.js';
import { rootRoutes } from '@pendwa/common/core/rootRoutes/index.js';
import { filterOutNullOrUndefined } from '@pendwa/common/utils/isDefinedAndNotNull.js';
import { EnumPermissionRole } from '@pendwa/db/generated/kysely/types-enums.js';

export const getFooterConfig = (params: { viewer?: IContextPageDataViewer }): IFooterConfig => {
  return {
    main: {
      link: {
        label: browserRootConfig.project.name,
        navigate: {
          description: 'Home',
          href: rootRoutes.home.main.get(),
        },
      },
      copy_text: `${new Date().getFullYear()} ${browserRootConfig.project.name} LLC. All rights reserved.`,
      summary: browserRootConfig.project.meta.home.description,
      facebook_url: browserRootConfig.social.facebook?.url,
      instagram_url: browserRootConfig.social.instagram?.url,
      twitter_url: browserRootConfig.social.twitter?.url,
    },
    columns: [
      {
        label: 'Site',
        links: filterOutNullOrUndefined([
          { label: 'Home', navigate: { description: 'Home', href: rootRoutes.home.main.get() } },
          params.viewer
            ? { label: 'Account', navigate: { description: 'Account', href: rootRoutes.settings.main.get() } }
            : undefined,
          params.viewer &&
          hasPermissionsAnd(params.viewer.permission_roles, [EnumPermissionRole.CONSOLE_ACCESS])
            ? { label: 'Console', navigate: { description: 'Console', href: rootRoutes.console.main.get() } }
            : undefined,
          {
            label: 'Help Center',
            navigate: { description: 'Help Center', href: browserRootConfig.project.help_url },
          },
          {
            label: 'Contact Us',
            navigate: { description: 'Contact Us', href: rootRoutes.app.contact.main.get() },
          },
        ]),
      },
    ],
  };
};
